import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { CreateHmac } from "../../routes/cryptography";
import FileDownload from "js-file-download";
import { Buffer } from "buffer"

class Hmac extends Component {
  constructor() {
    super();
    this.state = {
      data: "",

      filename: "файл",

      fileIsOpen: false,

      errors: {},
    };
    ///////VerifySign Func////
    this.handleInputChangeDataHmac = this.handleInputChangeDataHmac.bind(this);
    this.handleFileForHmacChange = this.handleFileForHmacChange.bind(this);
    this.handleHmacSubmit = this.handleHmacSubmit.bind(this);
  }

  componentDidMount() {}

  handleInputChangeDataHmac(e) {
    //console.log(e.target.value);
    try {
      if (e.target.value.length === 0) {
        //console.log("ok");
        document.getElementById("dataForHmac").disabled = false;
      } else {
        document.getElementById("dataForHmac").disabled = true;
      }
      this.setState({
        filename: "файл",
        fileIsOpen: false,
        // signFileName: "файл",
        // signFileIsOpen: false,
        // certFileName: "файл",
        // certFileIsOpen: false,

        data: btoa(unescape(encodeURIComponent(e.target.value))),
      });
      //console.log(e.target.value.length);

      // console.log(e.target.value);
    } catch (error) {
      //console.log(error);
    }
  }

  handleFileForHmacChange() {
    try {
      const file = document.getElementById("dataForHmac").files[0];
      //console.log(file);

      if (file !== undefined) {
        document.getElementById("inputDataHmac").disabled = true;
        this.setState({ filename: file.name, fileIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            data: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        document.getElementById("inputDataHmac").disabled = false;

        this.setState({ filename: "файл", fileIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleHmacSubmit(e) {
    e.preventDefault();
    try {
      CreateHmac(this.state.data).then((res) => {
        try {
          //console.log(res);
          if (res.status === 200) {
            FileDownload(res.data.hmac, "hmac.pem");
            document.getElementById("view").style.borderColor = "green";
          } else {
            document.getElementById("view").style.borderColor = "red";
          }
        } catch (error) {
          document.getElementById("view").style.borderColor = "red";

          //console.log(error);
        }
      });
    } catch (error) {
      //console.log(error);
    }
  }

  render() {
    return (
      <div className="container">
        <h4 className="major">Hmac-значение</h4>
        <Form onSubmit={this.handleHmacSubmit}>
          <div className="sm-4">
            <Form.Group>
              <Form.Label>Введите текст</Form.Label>
              <Form.Control
                id="inputDataHmac"
                onChange={this.handleInputChangeDataHmac}
                type="text"
                placeholder="Текст"
              />
            </Form.Group>

            <Form.Label style={{ marginLeft: "50%" }}>или</Form.Label>

            <Form.Group>
              <Form.Label>Выберите файл </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="dataForHmac"
                  onChange={this.handleFileForHmacChange}
                  isValid={this.state.fileIsOpen}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.filename}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
              </Form.File>
            </Form.Group>

            <Button
              style={{ float: "right" }}
              type="submit"
              size="sm"
            >
              Создать
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(Hmac));
